import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { images } from '../../constants';
import './Navbar.scss';

const Navbar = ({toggleDarkMode, isDarkMode}) => {
  const [toggle, setToggle] = useState(false);

    const switchElement = document.querySelector('.app__dark-light-toggle_switch');

    function toggleTheme() {
      toggleDarkMode(!isDarkMode)
    }

  return (
    <nav className={`app__navbar`}> 
      <div className="app__navbar-logo">
        <a href='#home'>
          <img src={images.logo} alt="logo" />
        </a>
      </div>
      <ul className={`app__navbar-links`}>
        {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
          <li className={`app__flex p-text`} key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className={`app__dark-light-toggle hide-when-small ${isDarkMode ? 'dark' : 'light'}`}  onClick={toggleTheme}>
          <div className={`app__dark-light-toggle_switch hide-when-small ${isDarkMode ? 'dark' : 'light'}`}></div>
      </div>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;